class Faqs {
    constructor(sel) {
        // view
        this.components = document.querySelectorAll(sel);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach(comp => {
            this.initQuestions(comp);
            this.initFilter(comp)
        })
    }
    initFilter(comp) {
        const categories = comp.querySelectorAll('.category');
        const filter = comp.querySelector('aside');
        const filterList = filter.querySelector('ul');
        categories.forEach((cat, i) => {
            cat.querySelector('.anchor').id = `category-${i}`;
            const name = cat.querySelector('h2').innerHTML;
            const li = document.createElement('li');
            li.innerHTML = `
            <a href="#category-${i}">${name}</a>
            `
            filterList.appendChild(li);
        })

        filter.addEventListener('click', () => {
            if (WW > 960) return;
            filter.classList.toggle('active');
        })
        document.body.addEventListener('click', (e) => {
            const isActive = filter.querySelector('header').classList.contains('active');
            if (WW > 960 || !isActive) return;
            console.log('click OUT');
            if (e.target === filter.querySelector('header')) return;
            console.log('click in');
            filter.classList.toggle('active', false);
        })
    }
    initQuestions(comp) {
        const questions = comp.querySelectorAll('.category li');
        questions.forEach(faq => {
            faq.addEventListener('click', () => {
                const isActive = faq.classList.contains('active');
                faq.classList.toggle('active');
                if (isActive) return;
                const offset = faq.getBoundingClientRect().y - (WW < 961 ? 70 : 80);
                const top = offset + window.scrollY;
                scrollTo({ top, behavior: 'smooth' })
            })
        })
    }
}

const example = new Faqs(".faqs");
